import { History } from 'history';
import { HttpResponse } from 'vrlcm-gui-utils';
import { KEY_LABEL_MAP } from '../common/display-policy';
import { LCOPS } from '../constants/AppConstants';

export function lastUrl(match: any) {
  const urls = match && match.split('/');
  let url: string;
  url = urls[urls.length - 1];
  url = prettify(url);
  return url;
}
/*replace "-" with space and make first letter capital after space*/
function prettify(url: string) {
  return url
    .split('-')
    .map(function capitalize(part) {
      return part.charAt(0).toUpperCase() + part.slice(1);
    })
    .join(' ');
}
export const getHeader = (header: string, headers?: any) => {
  if (headers && header) {
    let headerTuple: [string, any] | undefined;
    headerTuple = Object.entries(headers).find(
      ([key]) => key.toLowerCase() === header.toLowerCase()
    );
    if (headerTuple) {
      return headerTuple[1].toString();
    }
  }
};
/* return file name for content-disposition response header*/
export function getFileName(res: HttpResponse) {
  let filename = '';
  const header = getHeader('content-disposition', res.headers);

  if (header && header.indexOf('attachment') !== -1) {
    filename = header.substring(
      header.indexOf('filename') + 10,
      header.length - 1
    );
  }
  return filename;
}
/*return label for corresponding key */
export function keyToLabel(property: string) {
  return KEY_LABEL_MAP[property] || property;
}

export const redirectToEnv = (EnvId: string, history: History) => () => {
  history.push(`${LCOPS}/environments/${EnvId}`);
};

export const redirectToVC = (DCVmid: string, history: History) => () => {
  history.push(`${LCOPS}/datacenters?dataCenterVmid=${DCVmid}`);
};

export const redirectToSettings = (type: string, history: History) => () => {
  let url = `${LCOPS}/settings/`;
  url +=
    type === 'lcmrootpassword'
      ? 'change-password'
      : type === 'myvmware'
      ? 'my-vmware'
      : type;
  history.push(url);
};
